import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { Trash01 } from '../../../assets';
import { useEffect, useState } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTranslation } from 'react-i18next';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

interface SubmitModalProps {
  openModal: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const SubmitModal: React.FC<SubmitModalProps> = ({ openModal, onConfirm, onCancel }) => {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  const handleCancel = () => {
    onCancel();
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <Dialog
      onClose={handleCancel}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle>
        {t('deleteSchedule')}
        <CloseDialogAction onCancel={handleCancel} />
      </DialogTitle>
      <DialogContent
        sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="textMD"
          sx={{ my: 4, mx: 6 }}>
          {t('deleteScheduleConfirm')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ mt: 4, mb: 4, mr: 4 }}>
        <Button variant='secondary'
          size="lg"
          onClick={handleCancel}>
          {t('cancel')}
        </Button>
        <Button
          variant='bad'
          size="lg"
          onClick={handleConfirm}
          startIcon={<SvgIcon><Trash01 /></SvgIcon>}>
          {t('confirmDelete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default SubmitModal;